export default function WhyThis() {
  return (
    <section
      id="why"
      data-testid="why-section"
      className="relative py-20 sm:py-28 overflow-hidden"
    >
      <div className="max-w-[1400px] mx-auto px-6 sm:px-10 lg:px-16">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 items-start">
          {/* LEFT — Copy */}
          <div className="lg:col-span-6">
            <div className="reveal flex items-center gap-3 mb-6">
              <span className="h-[1px] w-10 bg-amber-500/70" />
              <span className="font-sans-body uppercase text-[11px] tracking-[0.32em] text-amber-400">
                The Diagnosis
              </span>
            </div>
            <h2
              data-testid="why-headline"
              className="reveal font-display font-light text-white text-4xl sm:text-5xl lg:text-[56px] leading-[1.05] tracking-[-0.01em] text-balance"
              style={{ transitionDelay: "80ms" }}
            >
              Why most advisors struggle to{" "}
              <span className="italic text-amber-400">convert leads.</span>
            </h2>

            <p
              className="reveal mt-6 text-slate-300 text-base sm:text-lg leading-relaxed max-w-xl"
              style={{ transitionDelay: "140ms" }}
            >
              Three things break every advisor pipeline — and they compound
              fast.
            </p>

            <ul className="reveal mt-8 space-y-4" style={{ transitionDelay: "200ms" }}>
              {[
                { t: "No consistent follow-up", s: "One touch, then silence." },
                { t: "Slow response times", s: "Leads cool in minutes — not hours." },
                { t: "No structured system", s: "Memory isn't a strategy." },
              ].map((it, i) => (
                <li key={it.t} className="flex items-start gap-4">
                  <span className="font-display text-amber-400 text-2xl leading-none mt-1">
                    {i + 1}
                  </span>
                  <div>
                    <div className="font-display text-xl text-white leading-tight">
                      {it.t}
                    </div>
                    <div className="text-sm text-slate-400 mt-1">{it.s}</div>
                  </div>
                </li>
              ))}
            </ul>
          </div>

          {/* RIGHT — Stat Callouts */}
          <div className="lg:col-span-6 grid grid-cols-1 sm:grid-cols-2 gap-5">
            <StatCallout
              value="79%"
              label="of leads never convert"
              source="HubSpot"
              sub="Due to lack of consistent follow-up"
              tone="rose"
            />
            <StatCallout
              value="21×"
              label="more likely to convert"
              source="Harvard Business Review"
              sub="When you respond within 5 minutes"
              tone="emerald"
            />
          </div>
        </div>
      </div>
    </section>
  );
}

function StatCallout({ value, label, source, sub, tone }) {
  const toneMap = {
    rose: {
      text: "text-rose-400",
      bg: "bg-rose-500/[0.06]",
      border: "border-rose-500/25",
      source: "text-rose-300/70",
    },
    emerald: {
      text: "text-emerald-400",
      bg: "bg-emerald-500/[0.06]",
      border: "border-emerald-500/25",
      source: "text-emerald-300/70",
    },
  };
  const t = toneMap[tone];
  return (
    <div className={`reveal ${t.bg} border ${t.border} p-7 flex flex-col justify-between min-h-[220px]`}>
      <div>
        <div className={`font-display text-6xl sm:text-7xl leading-none ${t.text}`}>
          {value}
        </div>
        <div className="mt-4 text-base text-white font-medium leading-snug">
          {label}
        </div>
        <div className="mt-2 text-sm text-slate-300 leading-relaxed">
          {sub}
        </div>
      </div>
      <div
        className={`mt-6 font-sans-body uppercase text-[10px] tracking-[0.24em] ${t.source}`}
      >
        Source · {source}
      </div>
    </div>
  );
}
